
import Vue from 'vue';

export function httpSendMobileCode(data) {
  return  Vue.$axios({
    url: '/api/user/verification_code/send',
    method: 'post',
    data
  })
}

export function httpDoRegister(data) {
  return  Vue.$axios({
    url: '/api/user/public/register',
    method: 'post',
    data
  })
}


export function httpDoLogin(data) {
  return Vue.$axios({
    url: '/api/user/public/login',
    method: 'post',
    data
  })
}

export function httpDoOauth(data) {
  return Vue.$axios({
    url: '/api/user/public/loginOauth',
    method: 'post',
    data
  })
}

export function httpResetPassword(data) {
  return Vue.$axios({
    url: '/api/user/public/passwordReset',
    method: 'post',
    data
  })
}


export function httpGetUserInfo(data) {
  return  Vue.$axios({
    url: '/api/user/profile/userInfo',
    method: 'get',
    data
  })
}

export function httpGetInitInfo() {
  return  Vue.$axios({
    url: '/api/wallet/main/init',
    method: 'get'
  })
  
}

export function httpGetOneQuanInfo(params) {
  return  Vue.$axios({
    url: '/api/user/profile/oneQuan',
    method: 'get',
    params
  })
  
}
